import { motion } from "framer-motion";

export default function PowerBanner() {
  return (
    <section className="relative bg-navy noise overflow-hidden" data-testid="power-banner">
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 pt-20 md:pt-28 pb-10 md:pb-14 grid md:grid-cols-5 gap-10 md:gap-12 items-start">
        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-2"
        >
          <p className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-[1.1] text-[#F8F9FA]">
            "Let's put the power back
            <span className="block">where it belongs —</span>
            <span className="block italic font-medium text-gold mt-1">with the people."</span>
          </p>
          <footer className="mt-6 text-[11px] uppercase tracking-[0.3em] font-semibold text-white/80">
            — Darwin "Dave" Williams
          </footer>
        </motion.blockquote>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-3"
        >
          <img
            src="/images/ceremony.jpg"
            alt="Community members in regalia at an honoring ceremony"
            className="w-full h-auto rounded-sm border border-white/15 shadow-[0_32px_64px_-24px_rgba(0,0,0,0.5)]"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
}
